import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { registerPushNotifications } from "../../utils/notificationUtil";
import {
  Input,
  Button,
  Heading,
  useToast,
  Card,
  Box,
  Text,
  FormLabel,
  FormControl,
  Container,
  VStack,
  HStack,
  Link,
} from "@chakra-ui/react";
// import axiosInstance from "../routes/axiosInstance";
import axiosInstance from "../../routes/axiosInstance";

const SignupPage = () => {
  const { loginUser } = useAuth();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPass, setUserPass] = useState("");
  const [userConfPass, setUserConfPass] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const submitSignup = async () => {
    if (!userName || !userEmail || !userPass || !userConfPass) {
      toast({
        title: "Signup Error",
        description: "Please fill all the required fields",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (userPass !== userConfPass) {
      toast({
        title: "Signup Error",
        description: "Passwords are not same.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const signupPayload = {
      name: userName,
      email: userEmail,
      password: userPass,
    };
    setLoading(true);
    const config = { headers: { "Content-type": "application/json" } };
    try {
      const userLoginData = await axiosInstance.post(
        "/api/users/register",
        signupPayload,
        config,
      );
      console.log(userLoginData.data);
      loginUser(userLoginData.data.data);

      toast({
        title: "Registration Successful",
        description: `Welcome to Vartalaap ${userLoginData.data.data.name}`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      setLoading(false);
      registerPushNotifications(userLoginData.data.data);
      navigate("/chats");
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage(error.message);
      }
      setLoading(false);
      toast({
        title: "Registration Failed",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const gotoLoginPage = () => {
    navigate("/login");
  };

  return (
    <Box bg="gray.50" minH="100vh">
      <Container
        maxW="md"
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={4}
        py={8}
      >
        <VStack spacing={6} w="100%" maxW="400px">
          {/* VartaVerse Brand Title */}
          <Heading
            fontSize="3xl"
            color="teal.500"
            fontWeight="700"
            cursor="pointer"
            onClick={() => navigate("/")}
            _hover={{
              color: "teal.600",
              transform: "scale(1.02)",
              textDecoration: "none",
            }}
            transition="all 0.2s"
            textAlign="center"
          >
            VartaVerse
          </Heading>

          {/* Signup Form */}
          <Card
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            p={8}
            w="100%"
            borderRadius="lg"
            boxShadow="sm"
          >
            <VStack spacing={6}>
              <VStack spacing={2} textAlign="center" mb={2}>
                <Heading fontSize="xl" color="gray.800" fontWeight="600">
                  Create your account
                </Heading>
              </VStack>

              <FormControl isRequired>
                <FormLabel
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="600"
                  mb={2}
                >
                  Full name
                </FormLabel>
                <Input
                  type="text"
                  placeholder="Enter your full name"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  bg="white"
                  border="1px solid"
                  borderColor="gray.300"
                  color="gray.900"
                  _placeholder={{ color: "gray.500" }}
                  _hover={{ borderColor: "gray.400" }}
                  _focus={{
                    borderColor: "teal.500",
                    boxShadow: "0 0 0 3px rgba(56, 178, 172, 0.1)",
                    outline: "none",
                  }}
                  size="md"
                  borderRadius="md"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="600"
                  mb={2}
                >
                  Email address
                </FormLabel>
                <Input
                  type="email"
                  placeholder="Enter your email"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  bg="white"
                  border="1px solid"
                  borderColor="gray.300"
                  color="gray.900"
                  _placeholder={{ color: "gray.500" }}
                  _hover={{ borderColor: "gray.400" }}
                  _focus={{
                    borderColor: "teal.500",
                    boxShadow: "0 0 0 3px rgba(56, 178, 172, 0.1)",
                    outline: "none",
                  }}
                  size="md"
                  borderRadius="md"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="600"
                  mb={2}
                >
                  Password
                </FormLabel>
                <Input
                  type="password"
                  placeholder="Create a password"
                  value={userPass}
                  onChange={(e) => setUserPass(e.target.value)}
                  bg="white"
                  border="1px solid"
                  borderColor="gray.300"
                  color="gray.900"
                  _placeholder={{ color: "gray.500" }}
                  _hover={{ borderColor: "gray.400" }}
                  _focus={{
                    borderColor: "teal.500",
                    boxShadow: "0 0 0 3px rgba(56, 178, 172, 0.1)",
                    outline: "none",
                  }}
                  size="md"
                  borderRadius="md"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel
                  color="gray.700"
                  fontSize="sm"
                  fontWeight="600"
                  mb={2}
                >
                  Confirm password
                </FormLabel>
                <Input
                  type="password"
                  placeholder="Confirm your password"
                  value={userConfPass}
                  onChange={(e) => setUserConfPass(e.target.value)}
                  bg="white"
                  border="1px solid"
                  borderColor="gray.300"
                  color="gray.900"
                  _placeholder={{ color: "gray.500" }}
                  _hover={{ borderColor: "gray.400" }}
                  _focus={{
                    borderColor: "teal.500",
                    boxShadow: "0 0 0 3px rgba(56, 178, 172, 0.1)",
                    outline: "none",
                  }}
                  size="md"
                  borderRadius="md"
                />
              </FormControl>

              <Button
                isLoading={loading}
                loadingText="Creating account..."
                size="md"
                width="full"
                onClick={submitSignup}
                bg="teal.500"
                color="white"
                _hover={{ bg: "teal.600" }}
                _active={{ bg: "teal.700" }}
                fontWeight="600"
                borderRadius="md"
                h="10"
              >
                Create account
              </Button>
            </VStack>
          </Card>

          {/* Login Link */}
          <Card
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            p={4}
            w="100%"
            borderRadius="lg"
            textAlign="center"
          >
            <HStack spacing={1} justify="center" color="gray.600">
              <Text fontSize="sm">Already have an account?</Text>
              <Link
                onClick={gotoLoginPage}
                color="teal.500"
                fontSize="sm"
                fontWeight="600"
                _hover={{ color: "teal.600", textDecoration: "underline" }}
                cursor="pointer"
              >
                Sign in
              </Link>
            </HStack>
          </Card>

          {/* Back to Home */}
          <Link
            onClick={() => navigate("/")}
            color="teal.500"
            fontSize="sm"
            fontWeight="500"
            _hover={{ color: "teal.600", textDecoration: "underline" }}
            cursor="pointer"
          >
            ← Back to homepage
          </Link>
        </VStack>
      </Container>
    </Box>
  );
};

export default SignupPage;
